/****** choose diamond function ********/
$(document).on("click", ".chooseDiamondLink", function() {
    var diamond = [{
        "diamond_id": $(this).data("diamondid"),
        "diamond_shape": $(this).data("shape"),
        "diamond_price": $(this).data("price"),
        "diamond_name": $(this).data("name"),
      "size" : $(this).data("carat")
    }];
    localStorage.setItem("pendant_diamond", JSON.stringify(diamond));
  localStorage.setItem('disable_pendant_add_to_cart' , 0)
    setSteps("diamond");
    // window.location.href = "/collections/ring-builder-engagement-rings-1";
});


/****** end of choose diamond *****/

/******* Choose Setting function start ******/

$(document).on("click", ".choose-setting", function() {
  
  if(!$("#SingleOptionSelector-0").val()){
    alert("PLEASE CHOOSE CHAIN LENGTH")
    return false
  }
  
    var setting = [{
        "product_id": $("#product_id").val(),
        "setting_id": $("#variant_id").val(),
        "setting_name": $("#variant_name").val(),
        "setting_price": $("#variant_price").val(),
        "setting_metal_type": $("#setting_metal_type").val(),
        "setting_ring_size": $('#ringsize').val(),
        "setting_sku": $("#variant_sku").val(),
        "setting_url": $("#variant_url").val(),
      	"setting_chainlength": $("#SingleOptionSelector-0").val(),
        "stock_num": $("#stock_num").val(),
        "no_of_center_stone": $("#no_of_center_stone").val(),
        "minimum_carat_total_weight": $("#minimum_carat_total_weight").val().replace('ct','').trim(),
        "maximum_carat_total_weight": $("#maximum_carat_total_weight").val().replace('ct','').trim(),
        "setting_type": $("#setting_type").val(),
        "meta_metal": $("#meta-metal").val(),
        "center_stone": $("#center_stone").val(),
        "can_be_match_with": $("#can_be_match_with").val(),
      	"image": $("#stockimg0").attr("src"),
      	"setting_style": $("#setting_style").val(),
      "side_stone_weight" : $("#side-stone-weight").val(),
      "pave_stone_weight" : $("#pave-stone-weight").val(),
      "setting_style":$("#setting_type").val(),
      "setting_description":$("#product_description").val(),
      "vendor_code": $("#vendor_code").val().trim(),
    }];
    localStorage.setItem("pendant_setting", JSON.stringify(setting));
  localStorage.setItem('disable_pendant_add_to_cart' , 0)
    setSteps("setting");
});
/******* Choose Setting function end  ******/


/*** set currenct step and redirect to next step start ****/
function setSteps(current_step) {

    if (localStorage.getItem("pendant_setting") && localStorage.getItem("pendant_diamond")) {
        localStorage.setItem("pendant_step3", "final pendant");
        var setting_info = JSON.parse(localStorage.getItem("pendant_setting"));
        var diamond_info = JSON.parse(localStorage.getItem("pendant_diamond"));
      	var diamond_price = (diamond_info[0].diamond_price);
      	var currency_rate = Shopify.currency.rate;
          var  dia_price = diamond_price * currency_rate; 
        var final_price = parseFloat(setting_info[0].setting_price/100) + parseFloat(dia_price);
     
      	final_price = parseFloat(final_price).toFixed(2);
      	final_price = Math.ceil(final_price) * 100;
        localStorage.setItem("pendant_final_ring_price", final_price);
        window.location.href = tps_config.urls.pendant_builder_final_page+"?setting_select=true&diamond_select=true" // "/pages/final-pendant";

    } else if (current_step == "diamond" && localStorage.getItem("pendant_setting")) {
        localStorage.setItem("pendant_step2", "diamond");
        window.location.href = tps_config.urls.pendant_builder_final_page+"?setting_select=true&diamond_select=true" // "/pages/final-pendant";
    } else if (current_step == "setting" && localStorage.getItem("pendant_diamond")) {
        localStorage.setItem("pendant_step2", "setting");
        window.location.href = tps_config.urls.pendant_builder_final_page+"?setting_select=true&diamond_select=true" //"/pages/final-pendant";
    } else if (current_step == "diamond" && !localStorage.getItem("pendant_setting")) {
        localStorage.setItem("pendant_step1", "diamond");
        localStorage.setItem("pendant_step2", "setting");
        window.location.href = tps_config.urls.pendant_builder_listing+"?setting_select=true" //"/collections/pendant-builder";
    } else if (current_step == "setting" && !localStorage.getItem("pendant_diamond")) {
      	localStorage.setItem("pendant_step1", "setting");
        localStorage.setItem("pendant_step2", "diamond");
        window.location.href = tps_config.urls.pendantbuilder_loose_diamond+"?diamond_select=true"  //"/pages/pendant-builder-diamond-listing";
    }


}
/*** set currenct step and redirect to next step end ****/


$(document).ready(function() {

  
  if((getQueryVariable('diamond_select') || getQueryVariable('setting_select') || getQueryVariable('id') || getQueryVariable('diamond_id') || window.location.pathname.indexOf('products') > -1  ) ){
   
  }else{
    if(localStorage.getItem("pendant_setting") || localStorage.getItem("pendant_diamond")){
    	localStorage.removeItem("pendant_diamond");
    localStorage.removeItem("pendant_setting");
    localStorage.removeItem("pendant_final_price");
    localStorage.removeItem("pendant_ringbuilder_dia_shape");
    localStorage.removeItem("pendant_step1");
    localStorage.removeItem("pendant_step2");
    localStorage.removeItem("pendant_step3");
    
      	window.location.href = tps_config.urls.pendant_builder_listing;
    }
   
  }
    // window.location.href = "/collections/ring-builder-engagement-rings-1";
});
/*** set currenct step and redirect to next step end ****/



function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  } 
  return false;
}